/* Added to an entity that should be in screenshots regardless of if in a frame */
class ScreenshotComponent {
    constructor() {
        this.typeId = ScreenshotComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
ScreenshotComponent.id = 2077;
export default ScreenshotComponent;
//# sourceMappingURL=ScreenshotComponent.js.map